import React, { useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import { apiRequestHandler } from '../apiConfig/service';
import ApiConfig from '../apiConfig/ApiConfig';

function Footer() {
  const contentRefs = useRef([]);
  const [openStates, setOpenStates] = useState([]);
  const [footerSections, setFooterSections] = useState([]);
  const fetchServices = async () => {
    const res = await apiRequestHandler({
      method: "GET",
      endPoint: ApiConfig.getAllServices,
    });
    console.log(res)
    if (res?.success && Array.isArray(res.data)) {
      setFooterSections(res.data);
      setOpenStates(new Array(res.data.length).fill(false));
    }
  };

  useEffect(() => {
    fetchServices();
  }, []);


  const toggleAccordion = (index) => {
    setOpenStates((prev) =>
      prev.map((isOpen, i) => (i === index ? !isOpen : isOpen))
    );
  };

  useEffect(() => {
    contentRefs.current.forEach((ref, i) => {
      if (ref) {
        ref.style.maxHeight = openStates[i] ? ref.scrollHeight + "px" : "0px";
      }
    });
  }, [openStates]);
  return (
    <div>
      <footer className="bg-gray overflow-hidden">
        <div className="container">
          <div className="f-items default-padding">
            <div className="row">
              <div className="col-lg-4 col-md-6 footer-item pr-30 pr-md-15 pr-xs-15">
                <div className="f-item address">
                  <img title='Microcode Software' src="/static/img/logo.png" alt="Img Not Found" />
                  <p>
                    Ready to take your business to the next level? Let’s create the perfect solution for you today!
                  </p>
                  <a className="btn btn-md circle btn-gradient animation mt-20" href="/contact" data-discover="true">Contact Us</a>


                </div>
              </div>
              <div className="col-lg-2 col-md-6 footer-item">
                <div className="f-item link">
                  <h4 className="widget-title">Quick Links</h4>
                  <ul>
                    <li>
                      <Link to="/blog">Blogs</Link>
                    </li>
                    <li>
                      <Link to="/">Home</Link>
                    </li>

                    <li>
                      <Link to="/about">About Us</Link>
                    </li>
                    <li>
                      <Link to="/pricing">Pricing & Plans</Link>
                    </li>
                    <li>
                      <Link to="/job">Career</Link>
                    </li>
                    <li>
                      <a href="/sitemap.xml" target="_blank" rel="noopener noreferrer">Sitemap</a>
                    </li>


                    <li>
                      <Link to="/contact">Contact Us</Link>
                    </li>

                  </ul>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 footer-item">
                <div className="f-item link">
                  <h4 className="widget-title">Our Services</h4>
                  <ul>
                    <li><Link to="/application-development">Application Development</Link></li>
                    <li><Link to="/social-media-marketing">Social Media Marketing</Link></li>
                    <li><Link to="/performance-marketing">Performance Marketing</Link></li>
                    <li><Link to="/software-development">Software Development</Link></li>
                    <li><Link to="/website-development">Website Development</Link></li>
                    <li><Link to="/shopify-development">Shopify Development</Link></li>
                    <li><Link to="/seo-services">Search Engine Optimization (SEO)</Link></li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 footer-item">

                <h4 className="widget-title">Our Location</h4>
                <ul className="contact-address border-0 m-0 p-0">
                  <li>

                    {/* <p>Our Location</p> */}
                    <p>J 27 / TF3, Gali No5, Rama Park Rd, Mohan Garden, Delhi, 110059</p>
                    <p>Texas, USA</p>
                  </li>
                </ul>
                <ul className="footer-social">
                  <li>
                    <a href="https://www.facebook.com/profile.php?id=100090409508146" target='blank'>
                      <i className="fab fa-facebook-f" />
                    </a>
                  </li>
                  <li>
                    <a href="https://www.linkedin.com/company/90959047/admin/dashboard/" target='blank'>
                      <i className="fab fa-linkedin-in" />
                    </a>
                  </li>

                  <li>
                    <a href="https://www.instagram.com/microcodesoftware/" target='blank'>
                      <i className="fab fa-instagram" />
                    </a>
                  </li>

                </ul>
              </div>
              <div className="col-lg-4 col-md-6 footer-item"></div>
              {/* <div className="col-lg-8 col-md-6 footer-item">
                <div className="row">
                  {footerSections.map((section, i) => (


                    <div className="col-lg-6 col-md-6 footer-item">
                      <div className="f-item link">
                        <h4 className="widget-title" style={{ marginTop: "16px", marginBottom: "16px" }}>{section.title}</h4>
                        <ul className="">
                          {section.items.map((item, idx) => (
                            <li key={idx} className="">
                              <Link to={`/${item}`}>
                                {item
                                  .split("-")
                                  .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                                  .join(" ")}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>


                  ))}
                </div>
              </div> */}
            </div>
          </div>
        </div>
        <div className="footer-bottom1  py-4">
          <div className="container">
            <div className="row">
              {footerSections.map((section, i) => (
                <div className="col-lg-4 mb-3" key={i}>
                  <div
                    style={{

                      borderRadius: "10px",
                      overflow: "hidden",
                      border: "none",
                      // transition: "background-color 0.3s, color 0.3s",
                    }}
                  >
                    <h5
                      className="d-flex justify-content-between align-items-center p-3"
                      style={{
                        fontSize: "16px",
                        cursor: "default", // no click behavior
                        marginBottom: "0",
                        borderBottom: "1px solid #dddddd",
                        fontWeight: "600"
                      }}
                    >
                      <span>{section.title}</span>

                    </h5>
                    <div
                      style={{
                        overflow: "visible",
                        // color: "#ffffff",
                      }}
                    >
                      <ul className="footer-bullets px-3 mt-2 mb-3">
                        {section.items.map((item, idx) => (
                          <li key={idx} className="py-1">
                            <Link to={`/${item}`} className="footer-link1">
                              {item
                                .split("-")
                                .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                                .join(" ")}
                            </Link>
                          </li>
                        ))}
                      </ul>


                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        {/* Start Footer Bottom */}
        <div className="footer-bottom bg-dark text-light">
          <div className="container">
            <div className="row">
              <div className="col-lg-6 text-start">
                <p>
                  © Copyright 2025. All Rights Reserved by <a href="/">Microcode</a>
                </p>
              </div>
              <div className="col-lg-6 text-end">
          <ul className="link-list">
            <li>
              <Link to="/terms-conditions">Terms & Condition</Link>
            </li>
            <li>
              <Link to="/privacy-policy">Privacy Policy</Link>
            </li>
            <li>
              <Link to="/refund-policy">Refund Policy</Link>
            </li>
          </ul>
        </div>
            </div>
          </div>

        </div>

        {/* <Link
          to="/granoble-app"
          rel="noopener noreferrer"
          className="whatsapp-float app-logo"
        >
          <img title='Microcode Software'
            src="static/img/icon/applogo.png"
            alt="Granoble App"
          />
        </Link> */}

        <a
          href="https://wa.me/+918882581143"
          target="_blank"
          rel="noopener noreferrer"
          className="whatsapp-float"
        >
          <img title='Microcode Software'
            src="/static/img/icon/whatsapp.png"
            alt="WhatsApp"
          />
        </a>

        {(() => {
          const startDate = new Date(2025, 7, 14); // Aug 14, 2025 (local)
          const endDate = new Date(2025, 7, 18);   // Aug 18, 2025 (local)
          const today = new Date();
          today.setHours(0, 0, 0, 0); // strip time

          if (today >= startDate && today <= endDate) {
            return (
              <img
                title="Microcode Software"
                id="flag"
                src="/static/img/icon/indian.gif"
                alt="WhatsApp"
              />
            );
          }
          return null;
        })()}


        {/* End Footer Bottom */}
      </footer>

    </div>
  )
}

export default Footer
